"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatState = void 0;
/**
 * Formats a given given state to valid state.
 *
 * Only accept letter characters
 * @param {string} input - The value to be formatted.
 * @returns {string} - The formatted state, or original/empty string based on conditions.
 */
const formatState = (input) => {
    const result = input.match(/^[A-Za-z]+$/g);
    if (result) {
        return result.join("").substring(0, 5);
    }
    return "";
};
exports.formatState = formatState;
